"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.keys.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FormDataProvider = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _client = require("@apollo/client");

var _reactAdaptiveHooks = require("react-adaptive-hooks");

var _emptyFunction = _interopRequireDefault(require("fbjs/lib/emptyFunction"));

var _log = require("@meepshop/logger/lib/gqls/log");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import
// graphql import
// definition
var FormDataContext = /*#__PURE__*/_react["default"].createContext(_emptyFunction["default"]);

var FormDataProvider = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      formData = _useState2[0],
      setFormData = _useState2[1];

  var formRef = (0, _react.useRef)(null);

  var _useNetworkStatus = (0, _reactAdaptiveHooks.useNetworkStatus)(),
      effectiveConnectionType = _useNetworkStatus.effectiveConnectionType;

  var _useMutation = (0, _client.useMutation)(_log.log, {
    onCompleted: function onCompleted() {
      if (formRef.current) {
        if (client) client.stop();
        formRef.current.submit();
      }
    }
  }),
      _useMutation2 = (0, _slicedToArray2["default"])(_useMutation, 2),
      mutation = _useMutation2[0],
      client = _useMutation2[1].client;

  (0, _react.useEffect)(function () {
    if ((formData === null || formData === void 0 ? void 0 : formData.type) === 'GET') window.location.href = formData.url || '';
    if (formRef.current) mutation({
      variables: {
        input: {
          type: 'INFO',
          name: 'CREATE_ORDER_FORM_DATA',
          data: {
            formData: formData,
            effectiveConnectionType: effectiveConnectionType
          }
        }
      }
    });
  }, [formData, effectiveConnectionType, mutation]);
  return /*#__PURE__*/_react["default"].createElement(FormDataContext.Provider, {
    value: setFormData
  }, !(formData !== null && formData !== void 0 && formData.params) || !formData.url ? null : /*#__PURE__*/_react["default"].createElement("form", {
    ref: formRef,
    method: "POST",
    action: formData.url,
    acceptCharset: /hitrust/.test(formData.url) ? 'big5' : 'utf8'
  }, Object.keys(formData.params).map(function (key) {
    var _formData$params;

    var value = (_formData$params = formData.params) === null || _formData$params === void 0 ? void 0 : _formData$params[key];
    if (key === '__typename' || !value) return null;
    return /*#__PURE__*/_react["default"].createElement("input", {
      key: key,
      name: key,
      value: value,
      type: "hidden",
      readOnly: true
    });
  })), children);
});

exports.FormDataProvider = FormDataProvider;
var _default = FormDataContext;
exports["default"] = _default;